export default () => {
  const formElement = document.querySelector('.potential-login-email-form') as HTMLFormElement;
  if (!formElement) return;

  const emailInputElement = formElement.querySelector('input[type="email"]') as HTMLInputElement;
  const submitButtonElement = formElement.querySelector('button[type="submit"]') as HTMLButtonElement;
  if (!emailInputElement || !submitButtonElement) return;

  let recaptchaToken = '';

  function validateEmail(email: string) {
    return RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(email);
  }

  function isGoogleEmail(email: string) {
    return RegExp(/@gmail.com$/).test(email.toLowerCase());
  }

  emailInputElement.addEventListener('input', () => {
    if (emailInputElement.classList.contains('error')) {
      const email = emailInputElement?.value ?? '';
      const isEmailValid = validateEmail(email);
      emailInputElement.classList.toggle('error', !isEmailValid);
    }

    if (submitButtonElement.parentElement?.classList.contains('warning')) {
      const email = emailInputElement?.value ?? '';
      const isGoogle = isGoogleEmail(email);
      submitButtonElement.parentElement?.classList.toggle('warning', isGoogle);
    }
  });

  formElement.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const email = emailInputElement?.value ?? '';
    const isEmailValid = validateEmail(email);
    
    emailInputElement.classList.toggle('error', !isEmailValid);
    emailInputElement.toggleAttribute('required', true);
    if (!formElement.checkValidity() || !isEmailValid) {
      emailInputElement.focus();
      return;
    }

    if (isGoogleEmail(email)) {
      const buttonWrapper = document.querySelector('.potential-login-email-form-button-wrapper');
      buttonWrapper?.classList.add('warning');
      return;
    }

    // @ts-ignore
    if (recaptchaToken || !window.grecaptcha) return;

    // @ts-ignore
    window.grecaptcha.ready(() => {
      // @ts-ignore
      window.grecaptcha.execute('6LeIVbkUAAAAADGkHSlBXnc0gqOSr6olTGfFZ4SJ', { action: 'submit' })
      .then((token: string) => {
        const recaptchaResponseElement = document.createElement('input');
        recaptchaResponseElement.type = 'hidden';
        recaptchaResponseElement.name = 'g-recaptcha-response';
        recaptchaResponseElement.value = token;
        formElement.appendChild(recaptchaResponseElement);
        recaptchaToken = token;
        formElement.submit();
      });
    });
  });

  submitButtonElement.toggleAttribute('disabled', false);
};